import Cookies, { CookieAttributes } from 'js-cookie';

import { APP } from '@/constants';

let jwtCookieDomain: string | undefined;

export const setJwtCookieDomain = (value?: string) => {
  jwtCookieDomain = value;
};

// This cookie MUST NOT be stored in any object; it MUST be retrieved in real time for every use case.
// This is because this cookie can be refreshed outside this application.
export const jwt = () => Cookies.get(APP.JWT_COOKIE_NAME);

export const setJwt = (value: string, options: CookieAttributes = {}) => Cookies.set(APP.JWT_COOKIE_NAME, value, {
  ...options,
  domain: options.domain ?? jwtCookieDomain,
});
